import { observer } from "mobx-react";
import * as React from "react";

import { Section } from "../ui/atoms/section";
import { SelectionMode } from "@fluentui/react";
import { ListLoginReport } from "../ui/molecules/list-login-report";
import sizes from "../ui/sizes.scss";
import { store } from "../store";
import { articles } from "../help";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageLoginReport extends React.Component {
    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[
                    articles.operatorTeamLoginReport,
                    articles.downloadDocuments,
                ]}
                breadcrumb={store.i18n.t("page.loginReport.title")}
                classic
            >
                <Section fill>
                    <ListLoginReport
                        selectionMode={SelectionMode.none}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
